import type { StyleRule } from '@archipro-design/aria';
import { labelClassName, paragraphClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const Wrap: StyleRule = ({ theme }) => ({
    width: '100%',
    borderTop: `1px solid rgba(52, 52, 52, 0.2)`,
    marginBottom: pxToRem(30),
    [theme.screen.laptop]: {
        borderWidth: '2px',
        marginBottom: pxToRem(60),
    },
});

export const ContentWrap: StyleRule = ({ theme }) => ({
    paddingTop: pxToRem(30),
    gridRow: 2,

    [theme.screen.laptop]: {
        paddingTop: pxToRem(34),
        paddingLeft: pxToRem(0),
        width: pxToRem(700),
        gridRow: 'unset',
    },

    [theme.screen.clamped]: {
        paddingLeft: 0,
        width: '50%',
    },

    [`&:empty`]: {
        display: 'none',

        [theme.screen.laptop]: {
            display: 'block',
        },
    },
});

export const ContentParagraph: StyleRule = ({ theme }) => ({
    [`&.${paragraphClassName}`]: {
        fontSize: pxToRem(14),
        lineHeight: pxToRem(18),
        fontWeight: 400,
        margin: 0,

        [theme.screen.laptop]: {
            fontSize: pxToRem(14),
            lineHeight: theme.siteVariables.lineHeightSmall,
            maxWidth: pxToRem(408),
        },

        [`& > *`]: {
            margin: 0,
        },
    },
});

export const Header: StyleRule = ({ theme }) => ({
    width: 'fit-content',
    paddingTop: pxToRem(21),
    position: `relative`,

    [`& .${labelClassName}:not(:first-child)`]: {
        display: 'inline-block',
    },

    [`& .${labelClassName}:first-child`]: {
        display: 'inline',
        margin: 0,
    },

    [theme.screen.laptop]: {
        paddingTop: pxToRem(34),
    },

    [`&:before`]: {
        content: `" "`,
        display: 'block',
        height: pxToRem(6),
        width: '100%',
        maxWidth: '100vw',
        background: theme.siteVariables.colors.charcoal[250],
        transform: `translate(0, ${pxToRem(-21)})`,

        [theme.screen.laptop]: {
            height: pxToRem(4),
            transform: `translate(0, ${pxToRem(-35)})`,
        },
    },
});

export const ItemCount: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(14),
    lineHeight: theme.siteVariables.lineHeightSmall,
    position: 'relative',
    bottom: pxToRem(27),
    marginLeft: pxToRem(7),
    display: 'inline-block',

    [theme.screen.laptop]: {
        bottom: pxToRem(64),
        fontSize: theme.siteVariables.fontSizes.caption03,
        marginLeft: pxToRem(8),
    },
});
